export const DECIMAL_INPUT_PATTERN = '^\\d+(?:[.,]\\d+)?$'

export const LETTER_PATTERN = /[a-z]/i

export function normalizeDecimalForApi(value: string): string {
  return value.replace(',', '.')
}

export function isValidDecimalInput(value: string): boolean {
  const normalized = value.trim()

  if (!normalized) {
    return true
  }

  return new RegExp(DECIMAL_INPUT_PATTERN).test(normalized)
}
